module.exports={render:function (){var _vm=this;
  return _vm._h('div', [(_vm.profile) ? _vm._h('img', {
    staticClass: "ui small circular image",
    attrs: {
      "src": _vm.profile.photo
    }
  }) : _vm._e(), " ", _vm._h('h4', ["Name: "]), " " + _vm._s(_vm._f("upper")(_vm.profile.name)) + "\n  ", _vm._h('h4', ["Description: "]), " " + _vm._s(_vm.profile.description) + "\n"])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-377d27ad!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProfileDetail.vue
// module id = 240
// module chunks = 2